import React, { useEffect, useState } from 'react';
//css
import '../assests/css/dashboard.css'
import '../assests/css/summary.css'
//icons
import ufilled from '../assests/icons/u(filled).svg';
import dollarfilled from '../assests/icons/dollar(filled).svg';
import HomeIcon2 from '../assests/webicons/homefilled.svg';
import BriefCase2 from '../assests/webicons/briefcase-filled.svg';
import { FaSpinner } from 'react-icons/fa';
//toaster popup
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SummaryHeader({ summaryData, isSummaryLoading, filterCategory, searchVal, filterClassification }) {
    const [work, setWrok] = useState(false);

    const [category, setCategory] = useState([]);
    const toastId = React.useRef(null);
const str1 = '00h 00m (0 visits) ';
const str2 = '$ 0.00';
const str5 = '$ ';
const str3 = '  (';
const str4 = ' visits)';
    useEffect(() => {
        // console.log("summaryData", summaryData)
        filterCategory(category);

    }, [category])

    useEffect(() => {
        // console.log("isSummaryLoading", isSummaryLoading)
        filterCategory([]);
        setCategory([])
    }, [isSummaryLoading])
    
    const handleCategory = (item) => {
        // console.log("item", item)
       if (category.includes(item)) {
            setCategory(category.filter(data => data !== item));
        } else {
            setCategory(oldArray => [...oldArray, item])
        }
    }

   
    return (
        <div className="row summary">
            <div
       className="col unclassified"
                style={{ backgroundColor: category.includes('U') ? '#DCDCDC' : '',border: category.includes('U') ? "2px solid #706565":"", boxShadow: category.includes('U') ? '' : '', cursor: "pointer" }}
                onClick={() => { handleCategory('U') }}
            >
                <span className="row align-items-center">
                    <span className="col-md-4 text-right pr-0 align-self-center">
                         <img src={ufilled} style={{ height: "30px" }} alt="unclassified" /></span>
                    <span className="col-md-8 text-left pl-0">
                        <span className="summary-header">&nbsp;&nbsp;&nbsp;Unclassified</span><br />
                        {(filterClassification && searchVal && category.includes('U')) ?
                            <></> :
                            <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;
                                {(isSummaryLoading) ?
                                    <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> :
                                    (summaryData.unclassifiedHours === null || summaryData.unclassifiedHours === undefined) ? "00h 00m (0 visits)" : summaryData.unclassifiedHours + "  (" + summaryData.unclassifiedVisits + " visits)"}
                            </span>}
                    </span>
                </span>
            </div>
            
            <div className="col personal"
                style={{ borderInline: "4px solid #C4C4C4", backgroundColor: category.includes('P') ? '#E1EBEF' : '',border: category.includes('P') ? "2px solid #0D7599":"", boxShadow: category.includes('P') ? '' : '', cursor: "pointer" }}
                onClick={() => { handleCategory('P') }}
            >
                <span className="row  align-items-center">
                    <span className="col-md-4 text-right pr-0 align-self-center"> <img src={HomeIcon2} style={{ height: "35px" }} alt="personal" /></span>
                    <span className="col-md-8 text-left pl-0">
                        <span className="summary-header">&nbsp;&nbsp;&nbsp;Personal</span><br />
                        {(filterClassification && searchVal && category.includes('P')) ?
                            <>the</> :
                            <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;
                                {(isSummaryLoading) ?
                                    <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> :
                                    (summaryData.personalHours === null || summaryData.personalHours === undefined) ? "00h 00m (0 visits)" : summaryData.personalHours + "  (" + summaryData.personalVisits + " visits)"}
                            </span>}
                    </span>
                </span>
            </div>

            <div className="col work"
                style={{ backgroundColor: category.includes('W') ? '#CAECE5' : '',border: category.includes('W') ? "2px solid #00755E":"", boxShadow: category.includes('W') ? '' : '', cursor: "pointer" }}
                onClick={() => { handleCategory('W') }}
            >
                <span className="row align-items-center">
                    <span className="col-md-4 text-right pr-0 align-self-center"> <img src={BriefCase2} style={{ height: "30px"}} alt="personal" /></span>
                    <span className="col-md-8 text-left pl-0">
                        <span className="summary-header">&nbsp;&nbsp;&nbsp;&nbsp;Work</span><br />
                        {(filterClassification && searchVal && category.includes('W')) ?
                            <></> :
                            <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;&nbsp;
                                {(isSummaryLoading) ?
                                    <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> :
                                    (summaryData.workHours === null || summaryData.workHours === undefined) ? "00h 00m (0 visits)" : summaryData.workHours + "  (" + summaryData.workVisits + " visits)"}
                            </span>
                        }
                    </span>
                </span>
            </div>

            <div className="col billable"
                style={{   paddingBlockEnd: "0px",
                    backgroundColor: category.includes('Y') ? '#FCEFEE' : '',border: category.includes('Y') ? "2px solid #BB241F":"", boxShadow: category.includes('Y') ? '' : '', cursor: "pointer" }}
                onClick={() => { handleCategory('Y') }}
            >
                <span className="row align-items-center">
                    <span className="col-md-4 text-right pr-0 align-self-center"> <img src={dollarfilled} style={{ height: "35px",marginBottom: (filterClassification && searchVal && category.includes('Y')) ? "0px" : "18px"}} alt="bill" /></span>
                    <span className="col-md-8 text-left pl-0">
                        <span className="summary-header1" style={{marginBottom : "10px !important"}}>&nbsp;&nbsp;Billable</span><br />
                        {(filterClassification && searchVal && category.includes('Y')) ?
                            <></> :
                            <span className="text-nowrap1 summary-header1">&nbsp;&nbsp;
                                {(isSummaryLoading) ?
                                    <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> :
                                    (summaryData.billableHours === null || summaryData.billableHours === undefined) ? (<span className="text-nowrap1 summary-header1">{str1}<br/>&nbsp;&nbsp;{str2}</span>): 
                                    // summaryData.billableHours + "  (" + summaryData.billableVisits + " visits)"
                        //  </span>
                       (<span className="text-nowrap1 summary-header1">{summaryData.billableHours}{str3}{summaryData.billableVisits}{str4}<br/>&nbsp;&nbsp;{str5}{summaryData.billableAmount}</span>)
                                }</span>   }
                    </span>
                </span>
            </div>
        </div>
    );
}

export default SummaryHeader;

// import React, { useEffect, useState } from 'react';
// //css
// import '../assests/css/dashboard.css'
// import '../assests/css/summary.css'
// //icons
// import ufilled from '../assests/icons/u(filled).svg';
// import dollarfilled from '../assests/icons/dollar(filled).svg';
// import HomeIcon2 from '../assests/webicons/homefilled.svg';
// import BriefCase2 from '../assests/webicons/briefcase-filled.svg';
// import { FaSpinner } from 'react-icons/fa';


// function SummaryHeader({ summaryData, isSummaryLoading, filterCategory, searchVal, filterClassification }) {

//     const [category, setCategory] = useState([]);

//     useEffect(() => {
//         // console.log("summaryData", summaryData)
//         filterCategory(category);

//     }, [category])

//     useEffect(() => {
//         // console.log("isSummaryLoading", isSummaryLoading)
//         filterCategory([]);
//         setCategory([])
//     }, [isSummaryLoading])

//     const handleCategory = (item) => {
//         // console.log("item", item)
//        if (category.includes(item)) {
//             setCategory(category.filter(data => data !== item));
//         } else {
//             setCategory(oldArray => [...oldArray, item])
//         }
//     }

//     // console.log("category", category)
//     // console.log("searchVal from summary", searchVal)
//     // console.log("filterCategory from summary", filterCategory)

//     return (
//         <div className="row summary">
//             <div
//                 className="col unclassified"
//                 style={{ backgroundColor: category.includes('U') ? '#e7e7e7b3' : '', boxShadow: category.includes('U') ? '#b1b1b1 0px 0px 30px inset' : '', cursor: "pointer" }}
//                 onClick={() => { handleCategory('U') }}
//             >
//                 <span className="row align-items-center">
//                     <span className="col-md-4 text-right pr-0 align-self-center">
//                         <img src={ufilled} style={{ height: "30px" }} alt="unclassified" /></span>
//                     <span className="col-md-8 text-left pl-0">
//                         <span className="summary-header">&nbsp;&nbsp;&nbsp;Unclassified</span><br />
//                         {(filterClassification && searchVal && category.includes('U')) ? 
//                         <></> : 
//                         <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;
//                         {(isSummaryLoading) ? 
//                         <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> : 
//                         (summaryData.unclassifiedHours === null || summaryData.unclassifiedHours === undefined) ? "00h 00m (0 visits)" : summaryData.unclassifiedHours + "  (" + summaryData.unclassifiedVisits + " visits)"}
//                         </span>}
//                     </span>
//                 </span>
//             </div>

//             <div className="col personal"
//                 style={{ borderInline: "4px solid #C4C4C4", backgroundColor: category.includes('P') ? '#268db12b' : '', boxShadow: category.includes('P') ? '#2596be96 0px 0px 30px inset' : '', cursor: "pointer" }}
//                 onClick={() => { handleCategory('P'); }}
//             >
//                 <span className="row  align-items-center">
//                     <span className="col-md-4 text-right pr-0 align-self-center"> <img src={HomeIcon2} style={{ height: "35px" }} alt="personal" /></span>
//                     <span className="col-md-8 text-left pl-0">
//                         <span className="summary-header">&nbsp;&nbsp;&nbsp;Personal</span><br />
//                         {(filterClassification && searchVal && category.includes('P')) ? 
//                         <></> : 
//                         <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;
//                         {(isSummaryLoading) ? 
//                         <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> : 
//                         (summaryData.personalHours === null || summaryData.personalHours === undefined) ? "00h 00m (0 visits)" : summaryData.personalHours + "  (" + summaryData.personalVisits + " visits)"}
//                         </span>}
//                     </span>
//                 </span>
//             </div>

//             <div className="col work"
//                 style={{ borderRight: "4px solid #C4C4C4", backgroundColor: category.includes('W') ? '#c6dbd091' : '', boxShadow: category.includes('W') ? '#51b587c9 0px 0px 30px inset' : '', cursor: "pointer" }}
//                 onClick={() => { handleCategory('W') }}
//             >
//                 <span className="row align-items-center">
//                     <span className="col-md-4 text-right pr-0 align-self-center"> <img src={BriefCase2} style={{ height: "30px" }} alt="personal" /></span>
//                     <span className="col-md-8 text-left pl-0">
//                         <span className="summary-header">&nbsp;&nbsp;&nbsp;&nbsp;Work</span><br />
//                         {(filterClassification && searchVal && category.includes('W')) ? 
//                         <></> : 
//                         <span className="text-nowrap summary-header">&nbsp;&nbsp;&nbsp;&nbsp;
//                         {(isSummaryLoading) ? 
//                         <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> : 
//                         (summaryData.workHours === null || summaryData.workHours === undefined) ? "00h 00m (0 visits)" : summaryData.workHours + "  (" + summaryData.workVisits + " visits)"}
//                         </span>
//                         }
//                     </span>
//                 </span>
//             </div>

//             <div className="col billable"
//                 style={{ backgroundColor: category.includes('Y') ? '#f5dfdfb3' : '', boxShadow: category.includes('Y') ? '#df8e8ede 0px 0px 30px inset' : '', cursor: "pointer" }}
//                 onClick={() => { handleCategory('Y') }}
//             >
//                 <span className="row align-items-center">
//                     <span className="col-md-4 text-right pr-0 align-self-center"> <img src={dollarfilled} style={{ height: "35px" }} alt="bill" /></span>
//                     <span className="col-md-8 text-left pl-0">
//                         <span className="summary-header">&nbsp;&nbsp;Billable</span><br />
//                         {(filterClassification && searchVal && category.includes('Y')) ? 
//                         <></> : 
//                         <span className="text-nowrap summary-header">&nbsp;&nbsp;
//                         {(isSummaryLoading) ? 
//                         <FaSpinner icon="spinner" spin={"true"} style={{ animation: "spin infinite 5s linear" }} /> : 
//                         (summaryData.billableHours === null || summaryData.billableHours === undefined) ? "00h 00m (0 visits)" : summaryData.billableHours + "  (" + summaryData.billableVisits + " visits)"}
//                         </span>}
//                     </span>
//                 </span>
//             </div>
//         </div>
//     );
// }

// export default SummaryHeader;